module.exports = __webpack_public_path__ + "static/logo-white-f2307e4d295dcf1fb880b70b15927cef.png";